import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './utils/global';

ReactDOM.render(<App />, document.getElementById('root'));
